<template>
  <div class="demo_basic_config" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>正在加载中...</div>
    </Spin>
    <Tabs v-model="tabValue" @on-click="changeTab">
<!--      <TabPane label="满意度配置" name="11" :style="tanPaneHeight" style="margin-left:-5%;"></TabPane>-->
      <TabPane label="工单通知配置" name="10" :style="tanPaneHeight" style="margin-left:-5%;">
        <div class="div_one">
          <div class="div_large_one">
            <div class="div_top_one">
              <div class="config_div_four">
                <p class="top_p_class">WEB</p>
              </div>
              <div class="config_div_four">
                <p class="top_p_trans">通知到客服界面</p></div>
            </div>
            <div class="div_top_one">
              <div class="config_div_four">
                <p class="top_p_class">Email</p></div>
              <div class="config_div_four">
                <p class="top_p_trans">抄送到员工的邮箱</p></div>
            </div>
            <div class="div_top_one">
              <div class="config_div_four"><p class="top_p_class">短信</p>
              </div>
              <div class="config_div_four">
                <p class="top_p_trans">需提前配置短信模板</p></div>
            </div>
            <div class="div_top_one">
              <div class="config_div_four"><p class="top_p_class">API</p>
              </div>
              <div class="config_div_four">
                <p class="top_p_trans">需开通工单API接口</p></div>
            </div>
          </div>
        </div>
        <div class="div_father_medium">
          <div style="width: 30%;height: 100%;float: left;">
            <p class="top_p_class">工单流转通知</p>
            <p class="bottom_p_trans">当下列情况发生时，通知对应员工</p>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;工单分配给员工</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in assignToEmpList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="assignToEmpList[index]"></Checkbox>
            </div>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;新建工单到达员工的服务组</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in newOrderToEmpGroupList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="newOrderToEmpGroupList[index]"></Checkbox>
            </div>
          </div>
        </div>
        <div class="div_father_medium">
          <div style="width: 30%;height: 100%;float: left;">
            <p class="top_p_class">工单回复通知</p>
            <p class="bottom_p_trans">当下列工单有新回复时，通知对应员工</p>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;员工创建的工单</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in empCreatedList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="empCreatedList[index]"></Checkbox>
            </div>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;员工处理中的工单</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in empProcessingList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="empProcessingList[index]"></Checkbox>
            </div>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;抄送给员工的工单</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in copyToEmpList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="copyToEmpList[index]"></Checkbox>
            </div>
          </div>
        </div>
        <div class="div_bigger">
          <div class="div_medium">
            <p class="top_p_class">&nbsp;&nbsp;&nbsp;&nbsp;员工所在组未分配的工单</p>
          </div>
          <div class="div_last_two">
            <div v-for="(option,index) in unassignedOfEmpGroupList" class="div_mini">
              <Checkbox class="order_class" :disabled="(index == 1 && '0' == isEmail) || (index==2 && '0' == isMsg) || (index==3 && '0' == isApi)" v-model="unassignedOfEmpGroupList[index]"></Checkbox>
            </div>
          </div>
        </div>
      </TabPane>
    </Tabs>
    <div class="btn_template">
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'

  export default {
    name: "WorkOrderConfig",
    mixins: [publicFunClass],
    props:{
      pageCode:String
    },
    data() {
      return {
        roleList: JSON.parse(localStorage.getItem("roleList")),
        screenHeight: {height: ''},
        tanPaneHeight: {height: ''},
        spinShow: false,
        tabValue: '10',
        companyType: localStorage.getItem("companyType"),
        configId:'',
        assignToEmpList:[false,false,false,false],
        newOrderToEmpGroupList:[false,false,false,false],
        empCreatedList:[false,false,false,false],
        empProcessingList:[false,false,false,false],
        copyToEmpList:[false,false,false,false],
        unassignedOfEmpGroupList:[false,false,false,false],
        isEmail:"0",
        isMsg:"0",
        isApi:"0",
      }
    },
    methods: {
      changeTab: function () {
        this.initPage();
      },
      //查询
      initPage: function () {
        this.isEmail = "0";
        this.isMsg = "0";
        this.isApi = "0";
        let that=this;
        let param={
          journalType:"null",
          menuId:"null",
          type:this.tabValue
        };
        this.spinShow=true;
        this.$http.post("config/selectConfig.json",param) .then(function (res) {
          let result = res.data.flag;
          that.spinShow = false;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.configId = '';
          that.isEmail = res.data.obj.isEmail;
          that.isMsg = res.data.obj.isMsg;
          that.isApi = res.data.obj.isApi;
          if(res.data.obj.configList && res.data.obj.configList.length > 0){
            //判断当前页面是否为工单配置页面，后期会增加满意度配置
            if(that.tabValue=='10'){
              if(res.data.obj.configList){
                that.configId = res.data.obj.configList[0].id;
                let newList=JSON.parse(res.data.obj.configList[0].configValue);

                //将数组中的1和0，转换成后台需要的true和false
                that.assignToEmpList = that.updateArray(newList.assignToEmp.split(","),1);

                that.newOrderToEmpGroupList = that.updateArray(newList.newOrderToEmpGroup.split(","),1);

                that.empCreatedList = that.updateArray(newList.empCreated.split(","),1);

                that.empProcessingList = that.updateArray(newList.empProcessing.split(","),1);

                that.copyToEmpList = that.updateArray(newList.copyToEmp.split(","),1);

                that.unassignedOfEmpGroupList = that.updateArray(newList.unassignedOfEmpGroup.split(","),1);
              }
            }
          }
        });
      },
      //保存
      save: function () {
        //将数组中的true和false，转换成后台需要的1和0
        let assignToEmp = JSON.parse(JSON.stringify(this.assignToEmpList));
        assignToEmp = this.updateArray(assignToEmp,0);

        let newOrderToEmpGroup = JSON.parse(JSON.stringify(this.newOrderToEmpGroupList));
        newOrderToEmpGroup = this.updateArray(newOrderToEmpGroup,0);

        let empCreated = JSON.parse(JSON.stringify(this.empCreatedList));
        empCreated = this.updateArray(empCreated,0);

        let empProcessing = JSON.parse(JSON.stringify(this.empProcessingList));
        empProcessing = this.updateArray(empProcessing,0);

        let copyToEmp = JSON.parse(JSON.stringify(this.copyToEmpList));
        copyToEmp = this.updateArray(copyToEmp,0);

        let unassignedOfEmpGroup = JSON.parse(JSON.stringify(this.unassignedOfEmpGroupList));
        unassignedOfEmpGroup = this.updateArray(unassignedOfEmpGroup,0);

        let newParam = {
          assignToEmp:assignToEmp.toString(),
          newOrderToEmpGroup:newOrderToEmpGroup.toString(),
          empCreated:empCreated.toString(),
          empProcessing:empProcessing.toString(),
          copyToEmp:copyToEmp.toString(),
          unassignedOfEmpGroup:unassignedOfEmpGroup.toString(),
        }
        let param={
          configValue:JSON.stringify(newParam),
          journalType:"工单参数配置=>保存",
          menuId:"3_d-5-1",
          type:this.tabValue,
          id:this.configId,
          isUse:this.isUse
        };
        let that=this;
        this.spinShow=true;
        this.$http.post("config/doSave.json",param) .then(function (res) {
          let result = res.data.flag;
          that.spinShow=false;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.$Modal.info({
            title: '提示',
            content: "基本配置保存成功"
          });
          that.initPage();
        });
      },
      //数组替换
      updateArray:function (array, flag) {
        for (let i=0;i<array.length;i++){
          if(flag < 1){
            if(array[i]){
              array[i] = "1";
            }else{
              array[i] = "0";
            }
          }else{
            if("1" == array[i]){
              array[i] = true;
            }else{
              array[i] = false;
            }
          }
        }
        return array;
      },
    },
    created() {
      this.screenHeight.height = this.mountHeight(133);
      this.tanPaneHeight.height = this.mountHeight(200);
      this.initPage();
    },
  }
</script>

<style scoped lang="css">
  .div_one{
    width: 100%;height: 55px;border-bottom: gray 1px solid;
  }
  .div_large_one{
    width: 70%;height: 100%;float: right
  }
  .div_top_one{
    width: 25%;height: 100%;float: left;
  }
  .config_div_four{
    align-items: center;display:flex;justify-content: center
  }
  .top_p_class{
    font-size: 18px;
    font-weight: 700;
  }
  .top_p_trans{
    font-size: 12px;color: #a9a8a8;
  }
  .bottom_p_trans{
    font-size: 15px;
    color: #a9a8a8;
  }
  .div_father_medium{
    width: 100%;height: 65px;padding-top: 5px;
  }
  .div_medium{
    width: 30%;height: 100%;float: left;align-items: center;display:flex;
  }
  .order_class{
    height: 23px;zoom:120%;
  }
  .order_class /deep/ .ivu-checkbox .ivu-checkbox-inner{
    border: 1px solid #897d7d;
  }
  .div_bigger{
    width: 100%;height: 55px;
  }
  .div_last_two{
    width: 70%;height: 100%;float: left
  }
  .div_mini{
    width: 25%;height: 100%;float: left;align-items: center;display:flex;justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/WorkOrderConfig.vue